// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 2026-06-25: Process Master master page styles */
.process_list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 2rem 2rem 0;
}

.process_item {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-left-width: 6px;
  border-left-style: solid;
  border-radius: 8px;
  padding: 12px 14px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}

.process_order {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f3f4f6;
  color: #111827;
  font-weight: 800;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.process_info {
  flex: 1 1;
  min-width: 0;
}

.process_name {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.process_meta {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}

.process_actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.process_item_clickable { cursor: pointer; transition: all 0.15s; }
.process_item_clickable:hover { box-shadow: 0 3px 8px rgba(0,0,0,0.10); transform: translateY(-1px); border-color: #f97316; }
`, "",{"version":3,"sources":["webpack://./src/app/Pages/ProcessMaster/processmaster.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,0BAA0B,eAAe,EAAE,qBAAqB,EAAE;AAClE,gCAAgC,sCAAsC,EAAE,2BAA2B,EAAE,qBAAqB,EAAE","sourcesContent":["/* 2026-06-25: Process Master master page styles */\n.process_list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 0 2rem 2rem 0;\n}\n\n.process_item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-left-width: 6px;\n  border-left-style: solid;\n  border-radius: 8px;\n  padding: 12px 14px;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.04);\n}\n\n.process_order {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: #f3f4f6;\n  color: #111827;\n  font-weight: 800;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.process_info {\n  flex: 1;\n  min-width: 0;\n}\n\n.process_name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.process_meta {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 4px;\n}\n\n.process_actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.process_item_clickable { cursor: pointer; transition: all 0.15s; }\n.process_item_clickable:hover { box-shadow: 0 3px 8px rgba(0,0,0,0.10); transform: translateY(-1px); border-color: #f97316; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
